import { Field } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import { Form } from 'react-bootstrap'

const propTypes = {
  /**
   * Name of the field
   * For checkbox groups give all the checkboxes the same name
   */
  name: PropTypes.string.isRequired,
  /**
   * Id of the field, each checkbox in the group should have a different id
   */
  id: PropTypes.string.isRequired,
}

/**
 * Handles a checkbox with Formik for GROUP use.
 * Use this only for custom cases, perfer FormikCheckboxGroup if you want to pass the whole group as options
 */
function FormikCheckboxGroupItem(props) {
  const { id, name } = props

  return (
    <Field name={name} value={id}>
      {({ field }) => (
        <Form.Check
          {...props}
          custom
          type="checkbox"
          value={id} // formik needs the value set in the checkboxes
          id={id}
          name={name}
          checked={field?.value?.includes(id) ?? false}
          onChange={field.onChange}
          onBlur={field.onBlur}
        />
      )}
    </Field>
  )
}

FormikCheckboxGroupItem.propTypes = propTypes

export default FormikCheckboxGroupItem
